import { serverEmailRealSchema } from '@mindfulchefuk/features/Onboarding/utils/emailSchema'
import {
  GiftCardSubmitHandler,
  GiftCardFormState,
} from '@mindfulchefuk/features/GiftCards/interfaces'
import { FormikConfig } from 'formik'
import { useCallback } from 'react'

type Hook = (
  onSubmit: GiftCardSubmitHandler
) => FormikConfig<GiftCardFormState>['onSubmit']

/** Returns a Formik onSubmit handler that also validates the email is real and we can deliver to the postcode */
export const useGiftCardRecipientSubmit: Hook = (onSubmit) =>
  useCallback(
    async (fields, formikHandlers) => {
      const { setSubmitting, setFieldError } = formikHandlers
      setSubmitting(true)

      const emailPromise = serverEmailRealSchema
        .validate(fields.recipientEmail)
        .catch((error) => error)

      const emailResult = await Promise.resolve([emailPromise])

      if (emailResult instanceof Error) {
        setFieldError('recipientEmail', emailResult.message)
      }

      if (emailResult instanceof Error) {
        setSubmitting(false)
        return
      }

      onSubmit(fields, formikHandlers)
    },
    [onSubmit]
  )
